// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5e9a6c19","513":"703e13bf","703":"36a7d379"}[chunkId] + ".chunk.js";
};